import script from "./SecTrustRow.vue?vue&type=script&setup=true&lang=js"
export * from "./SecTrustRow.vue?vue&type=script&setup=true&lang=js"

import "./SecTrustRow.vue?vue&type=style&index=0&id=8f5ec770&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f5ec770"]])

export default __exports__